<template>
  <v-form v-model="valid">
    <v-container>
      <v-row>
        <v-col v-if="response && response.price" cols="12" md="12">
          <v-list subheader two-line>
            <v-subheader>{{ $t('summary') }}{{ response.targetLangName }}</v-subheader>
            <div v-for="[key, value] of Object.entries(response.price)" :key="key">
              <v-list-item v-if="value.currency_amount_decimal">
                <v-list-item-content>
                  {{ $t(key, { rate: response.price.tax }) }}
                </v-list-item-content>
                <v-list-item-action>
                  {{ value.currency_amount_decimal }} {{ value.currency_code }}
                </v-list-item-action>
              </v-list-item>
            </div>

            <!-- <v-list-item>
              <v-list-item-content>
                {{ $t('words') }}
              </v-list-item-content>
              <v-list-item-action>
                {{ response.words }}
              </v-list-item-action>
            </v-list-item> -->
          </v-list>
        </v-col>
        <v-row>
          <v-col cols="12" class="circle-center">
            <v-progress-circular
              v-if="showProgressBar"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <v-btn v-else color="primary" @click="submit(response)">
              {{ $t('request_order') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OrderSummary',
  props: {
    url: {
      type: String,
      default: '',
    },
    response: {
      default: () => {},
    },
  },
  data: () => ({
    valid: false,
    showProgressBar: false,
    targetLang: '',
  }),
  methods: {
    submit(item) {
      this.showProgressBar = true;

      const id = Number(item.id);
      let data = JSON.stringify({
        orderId: id
      });
      axios.post( `${ this.url }?action=completeTurboTranslateOrder`, data)
        .then( res => {
          if( res.data.code == 200 ){
            this.$emit('success', res.data.message );
          }else{
            this.$emit('error', res.data.message );

          }
          this.showProgressBar = false;
        })
        .catch( err => {
          this.$emit('error', err)
          this.showProgressBar = false;
        })
    },
  },
};
</script>
<style scoped>
.circle-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
